module.exports = __webpack_public_path__ + "static/media/MBOLE_darker.1c63f61c.webp";